export default {
  data() {
    return {
      models: [
        {
          value: "contractor",
          text: "Contractor",
          resourceTypes: [
            {
              value: 'compensationInsurance',
              text: 'Workers Compensation Insurance'
            },
            {
              value: 'liabilityInsurance',
              text: 'Public Liability Insurance'
            },
            {
              value: 'plantAndEquipInsurance',
              text: 'Plant & Equipment Insurance'
            }
          ]
        },
        {
          value: "vehicle",
          text: "Vehicle",
          nameField: 'vehicleName_vehicleType_contractorName',
          resourceTypes: [
            {
              value: 'registration',
              text: 'Registration Papers'
            },
            {
              value: 'pinkSlip',
              text: '6 Monthly Pink Slip'
            },
          ]
        },
        {
          value: "driver",
          text: "Driver",
          nameField: 'driverName_contractorName',
          resourceTypes: [
            {
              value: 'licence',
              text: 'Licence'
            },
            {
              value: 'voc',
              text: 'VOC'
            },
            {
              value: 'soa',
              text: 'Statement of Attainment'
            }
          ]
        },
      ],
    }
  },
  methods: {
    getResourceTypes() {
      this.resourceTypes = [];
      for (var model of this.models) {
        if (model.value == this.model || !this.model) {
          Array.prototype.push.apply(this.resourceTypes, model.resourceTypes);
        }
      }
    }
  }
}